import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=36641cca&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=36641cca&prod&lang=less&scoped=true"
import style1 from "./edit.vue?vue&type=style&index=1&id=36641cca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36641cca",
  null
  
)

export default component.exports